import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import X from 'react-feather/dist/icons/x';
import { CONSTANTS } from '../../constants/constants';
import NRButtonProgress from '../NRButtonProgress/NRButtonProgress';

const { CONFIRM, CANCEL, CLOSE_TOOLTIP } = CONSTANTS.CONFIRMATION_MODAL;

function NRConfirmationModal({
  title,
  actionLabel = CONFIRM,
  cancelLabel = CANCEL,
  subtitle,
  content,
  open,
  handleClose,
  handleActionConfirm,
  handleCancel,
  modalWidth,
  actionDisabled = false,
  actionLoading = false
}) {
  const theme = useTheme();

  const handleConfirm = () => {
    handleActionConfirm();
  };

  const body = (
    <Box
      role="dialog"
      aria-modal="true"
      aria-labelledby="nr-confirmation-modal-title"
      tabIndex={-1}
      sx={{
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: theme.palette.background.paper,
        position: 'absolute',
        width: modalWidth ?? 500
      }}
    >
      <Card>
        <CardHeader
          sx={{ p: theme.spacing(2, 3) }}
          titleTypographyProps={{ id: 'nr-confirmation-modal-title', sx: { ...theme.typography.h3 } }}
          title={title}
          subheader={subtitle}
          action={
            <Tooltip title={CLOSE_TOOLTIP} placement="right">
              <IconButton aria-label="Close" onClick={handleClose} size="large" autoFocus={open}>
                <X />
              </IconButton>
            </Tooltip>
          }
        />
        <CardContent sx={{ p: theme.spacing(1, 3, 5) }}>{content}</CardContent>
        <CardActions
          sx={{
            p: theme.spacing(1.5, 3),
            justifyContent: 'flex-end',
            '& > :not(:first-of-type)': {
              ml: theme.spacing(2)
            }
          }}
        >
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            {cancelLabel}
          </Button>
          <NRButtonProgress
            variant="contained"
            color="secondary"
            onClick={handleConfirm}
            disabled={actionDisabled}
            isLoading={actionLoading}
            fullWidth={false}
            label={actionLabel}
          />
        </CardActions>
      </Card>
    </Box>
  );

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="nr-confirmation-modal-title">
      {body}
    </Modal>
  );
}
export default NRConfirmationModal;
